import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ConcertCard from './ConcertCard';
import Button from '../../../react/components/Button';

import { concertsArrayPropTypes } from '../propTypes';
import { getClassNames } from '../../../utils';

const ConcertsSortedByDate = ({ concerts, setModal }: ConcertsSortedByDateProps) => {
  const cardsPerLoad = 6;

  const isCurrentOffSaleDateTime = (finalTime: number) => (
    finalTime ? finalTime > Math.floor(Date.now() / 1000) : true
  );

  const [cardsToShow, setCardsToShow] = useState(cardsPerLoad);

  if (concerts.length === 0) {
    return (
      <p className="c-cyop__filterbar-heading">No concerts currently available</p>
    );
  }

  return (
    <div>
      <p className="c-cyop__filterbar-heading">{`Found ${concerts.length} concerts.`}</p>

      {concerts.filter(({ finalPerformanceOffSaleDateAndTime }) => isCurrentOffSaleDateTime(
        parseInt(finalPerformanceOffSaleDateAndTime, 10),
      )).map((concert, index) => (
        <div
          className={getClassNames(null, 'o-col o-col--12 o-col--6@medium o-col--4@large', {
            'u-hide': index >= cardsToShow,
          })}
          key={concert.title}
        >
          <div className="o-col__inner">
            <ConcertCard
              blocks={concert.detailedContent.blocks}
              image={concert.image || ''}
              performancesViewTeaser={concert.performancesViewTeaser}
              productionSeasonId={concert.productionSeasonId}
              setModal={setModal}
              synopsis={concert.synopsis}
              title={concert.title}
            />
          </div>
        </div>
      ))}
      {concerts.length > cardsToShow && (
        <div className="c-cyop__button">
          <Button onClick={() => setCardsToShow(cardsToShow + cardsPerLoad)}>
            Load more
          </Button>
        </div>
      )}
    </div>
  );
};

const concertsSortedByDatePropTypes = {
  concerts: concertsArrayPropTypes.isRequired,
  setModal: PropTypes.func.isRequired,
};

ConcertsSortedByDate.propTypes = concertsSortedByDatePropTypes;

type ConcertsSortedByDateProps = PropTypes.InferProps<typeof concertsSortedByDatePropTypes>;

export default ConcertsSortedByDate;
